import { cn } from '@/util/cn'
import { IChannel } from '@giphy/js-types'
import { useContext } from 'react'
import { ModalContext } from '../modal'
import { cardClassName, CollectionLabel, gifBorderClassName, newCollectionImage, PlaceholderImage } from './ui'

const NewCollectionButton = ({
    className,
    channel,
    height,
}: {
    className?: string
    channel: IChannel
    width?: number
    height?: number
}) => {
    const { setModalType } = useContext(ModalContext)
    const isSubChannel = channel.ancestors.length > 0
    return (
        <div
            onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                setModalType({
                    name: 'createCollection',
                    channelId: channel.id,
                    title: `Create new collection in "${channel.display_name}"`,
                })
            }}
            className={cn(
                cardClassName,
                'bg-giphyDarkCharcoal hover:border-giphyDarkCharcoal outline-2 outline-transparent',
                className
            )}
        >
            <div className={cn(gifBorderClassName, 'absolute inset-0')}></div>
            <PlaceholderImage src={newCollectionImage} width={`100%`} height={height} />
            <CollectionLabel label={`New ${isSubChannel ? 'Sub-' : ''}Collection`} />
        </div>
    )
}

export default NewCollectionButton
